import './css/privacidad.css';
function Privacidad(){
    
    return(
        <main>
            <img src="img/logo_azul.png" alt="Imagen de nosotros - Universidad Monte Albán" id="logo_nosotros"/>
            <h1 id="nombre">Universidad <span id="nombre_universidad">Monte Albán</span> - Aviso de privacidad</h1>
            <h2 id="lema">Formamos líderes para transformar al mundo</h2>
            <h3 style={{
                color: 'black'
            }}>MONTE ALBAN SCHOOL MORELOS S.C</h3>
            <h3
                style={{
                    color: 'black'
                }}
            >AVISO DE PRIVACIDAD</h3>
            <section id="aviso-privacidad">
                <p>
                Universidad Monte Alban, con domicilio en calle Ambar #1 esquina paseo Cuauhnáhuac
    Col. La Joya, Yautepec Morelos. Es responsable de recabar sus datos personales, del uso 
    que se le dé a los mismos y de su protección.
                </p>
                <p>
                Su información personal será utilizada para proveer los servicios y productos que ha 
    solicitado, informarle sobre cambios en los mismos y evaluar la calidad del servicio que le 
    brindamos. Concretamente: administrar la matricula de las personas físicas o morales que 
    tienen alguna relación de cualquier tipo con Monte Alban School Morelos S.C, en su 
    carácter de aspirantes a alumnos, alumnos egresados, profesores, personal laboral, 
    proveedores, asociaciones e instituciones científicas y académicas. Para las finalidades 
    antes mencionadas, requerimos obtener los siguientes datos personales que se le 
    recabaran a través del formato que en su caso se instrumente.
                </p>
                <p>
                Los datos solicitados son pertinentes puesto que a través de ellos buscamos conocer la 
    información que conforme a nuestros criterios nos permite tomar las decisiones 
    correspondientes respecto de la relación especifica con cada uno de los titulares.
                </p>
                <p>
                La institución educativa antes citada no llevara a cabo transferencias de datos de la 
    información recabada. Así mismo no recaba datos personales sensibles.
                </p>
                <p>
                Usted tiene derecho a acceder, rectificar y cancelar sus datos personales, así como de 
    oponerse al tratamiento de los mismos o revocar el consentimiento que para tal fin nos haya 
    otorgado, a través de los procedimientos que hemos implementado. Para conocer dichos 
    procedimientos, los requisitos y plazos, se puede poner en contacto con nuestro 
    departamento de datos personales con la Universidad Monte Albán, con domicilio en calle 
    Ambar #1 esquina paseo Cuauhnáhuac Col. La Joya en Yautepec Morelos, con correo
    electrónico universidadmontealban@gmail.com o visitar nuestra página de internet 
    www.umontealban.edu.mx
                </p>
                <p>
                Si usted desea dejar de recibir mensajes promocionales de nuestra parte puede solicitarlo 
    a través de teléfono (777) 526-25-14 y/o 564-67-94, o en el domicilio calle ámbar #1 esquina 
    paseo Cuauhnáhuac, col. La Joya en Yautepec Morelos. O por medio del correo electrónico 
    universidadmontealban@gmail.com
                </p>
                <p>
                Cualquier modificación a este aviso de privacidad podrá consultarlo en 
                universidadmontealban@gmail.com
                </p>
                <p>
                El presente aviso de privacidad se le pone a su disposición a través de formatos impresos.
                </p>
                <p>
                La institución educativa antes citada ha tomado y permanentemente actualiza las medidas
    de seguridad administrativas, técnicas y físicas necesarias para proteger los datos 
    personales o de los titulares contra daño, perdida, alteración, destrucción o uso, acceso o 
    tratamiento no autorizado
                </p>
                <p>
                Todo lo anterior en cumplimiento de los artículos 8,15,16,17,18 y 36 de la Ley Federal de 
                Protección de Datos Personales en Posesión de Particulares.
                </p>
                <p>
                Fecha ultima de actualización 10/11/2021
                </p>
                <p style={{fontWeight:"bold"}} className='centered'>
                Atentamente
                </p>
                <p className='centered'>Universidad <span className='blue'>Monte Albán</span> - Aviso de privacidad</p>
            </section>
        </main>
    );
}
export default Privacidad;